import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { Book } from "../../../rest/models";
import { useEffect } from "react";
import { BookReadComponent } from "./BookReadComponent";
import { bookReaderActions } from "./slice";
import { GetPageTitle } from "../../../ErnotsConfig";
import { PleaseWait } from "../../CommonComponents";

export function BookPreview()
{
    const appDispatch = useAppDispatch();
    let pageTitle = '';
    
    useEffect(function()
    {
        appDispatch(bookReaderActions.init());
    }, [appDispatch]);

    useEffect(function()
    {
        function requestBookContent()
        {
            const wo = window.opener as Window;
            if (wo?.postMessage)
            {
                wo.postMessage('requestBookContents', window.location.origin);
            }
        };

        function receiveMessage(e: MessageEvent)
        {
            const d = e.data as Book;
            if (d?.modelClassName === 'Book')
            {
                appDispatch(bookReaderActions.setBook(d));
            }
        }

        window.addEventListener('message', receiveMessage, false);
        requestBookContent();

        function onUnmount()
        {
            window.removeEventListener('message', receiveMessage);
        }
        return onUnmount;
    }, [appDispatch]);
 
    const bookId = useAppSelector((state) => state.bookReader.book?.id);
    const bookTitle = useAppSelector((state) => state.bookReader.book?.title);
    
    let ret = <PleaseWait what='book data'/>;
    if (bookId)
    {
        pageTitle = `Previewing "${bookTitle}"`;
        ret = <BookReadComponent isPreview={true}/>;
    }

    return (
    <>
        <title>{GetPageTitle(pageTitle)}</title>
        {ret}
    </>);
}